import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgOutlinedCheckmark = (props: ISvgProps) => {
    return (
        <svg
            width="15"
            height="12"
            viewBox="0 0 15 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
        >
            <path
                d="M5.04555 8.65688L2.02767 5.639L1 6.65943L5.04555 10.705L13.7301 2.02043L12.7097 1L5.04555 8.65688Z"
                fill={props.color}
                stroke={props.color}
            />
        </svg>
    )
}
